import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TransferService } from '../../services/transfer.service';
import { TransferLabeledProductService } from '../../services/transfer-labeledproduct.service';
import { ShopService } from '../../../configuration/services/shop.service';
import { LabeledProductService } from '../../../labeledproducts/services/labeledproduct.service';
import { LabeledProductShopStockService } from '../../../labeledproducts/services/labeledproductshopstock.service';
import htmlDocx from 'html-docx-js/dist/html-docx';
import * as FileSaver from 'file-saver';
import * as JsBarcode from 'jsbarcode';
import * as moment from 'moment/moment';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
declare var JSZip: any;
declare var Docxtemplater: any;
declare var JSZipUtils: any;
declare var ImageModule: any;
declare var fs: any;
declare var Buffer: any;


@Component({
  selector: 'app-transfer',
  templateUrl: './view-transfer.component.html',
  styleUrls: ['./view-transfer.component.css'],
  providers: [TransferService, ShopService,LabeledProductService, LabeledProductShopStockService,TransferLabeledProductService]
})
export class ViewTransferComponent implements OnInit {
  id: number = undefined;
  private sub: any;
  role: any = 3;
  shops:any = [];
  shop_id_origin:any = null;
  shop_id_destination:any = null;
  stock_to_move:any = 1;
  labeledProductShopsStock:any = [];
  labeledProduct:any = {};
  photos:any = [];
  barcode = null;
  transfer:any = {};
  transferLabeledProducts:any = [];
  isOrigin: boolean;
  isDestination: boolean;

  config: any = {'sourceField': ['name']};
  stocks: any = [
    {id:1, name:"1"},
    {id:2, name:"2"},
    {id:3, name:"3"},
    {id:4, name:"4"},
    {id:5, name:"5"},
    {id:6, name:"6"},
    {id:7, name:"7"},
    {id:8, name:"8"},
    {id:9, name:"9"},
    {id:10, name:"10"}
  ]

  constructor(private transferService: TransferService,private route: ActivatedRoute, private labeledProductShopStockService:LabeledProductShopStockService, 
    private router: Router, private shopService:ShopService, private labeledProductService: LabeledProductService, private transferLabeledProductService:TransferLabeledProductService,
    public toastr: ToastsManager,vcr: ViewContainerRef) { 
      this.toastr.setRootViewContainerRef(vcr); 
    }

  ngOnInit() {
    this.getShops().then(()=>{
      this.sub = this.route.params.subscribe(params => {
        if (params['id'] !== undefined){
          this.id = params['id'];
          this.getTransfer();
        }
      });
      try{
        this.role = JSON.parse(localStorage.getItem('user')).role;
        this.shop_id_origin = parseInt(localStorage.getItem('shop'));
      }catch(e){
      }
    });
    
  }
  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getTransfer(){
    this.transferService.get(this.id)
      .subscribe((transfer) => {
        this.transfer = transfer;
        this.shop_id_origin = this.transfer.shop_id_origin.id;
        this.shop_id_destination = this.transfer.shop_id_destination.id;
        this.isOrigin = parseInt(localStorage.getItem('shop')) == this.shop_id_origin?true:false;
        this.isDestination = parseInt(localStorage.getItem('shop')) == this.shop_id_destination?true:false;
        this.getTransferLabeledProducts();
    });
  }

  stockSelected(e){
    this.stock_to_move = e.name
  }

  getTransferLabeledProducts(){
    var params = {
      where: {transfer_id:this.transfer.id},
      sort: 'id DESC',  
    };
    this.transferLabeledProductService.query(params)
      .subscribe((transferLabeledProducts) => {
        this.transferLabeledProducts = transferLabeledProducts;
        this.checkIfAllValidated();
    });
  }

  getShops(){
    return new Promise((resolve, reject) => {
        this.shopService.query({})
        .subscribe((shops) => {
            this.shops = shops;
            resolve();
        });
    });
  }

  create(){
    let body = {
      shop_id_origin:this.shop_id_origin,
      shop_id_destination:this.shop_id_destination,
    }
    this.transferService.create(body)
    .subscribe((transfer) => {
      this.transfer = transfer;
      this.router.navigate(['/transfer/view/'+this.transfer.id]);
    });
  }

  getLabeledProduct(barcode){
    if (barcode.length == 13){
      var params = {
          where: {barcode:{contains:barcode}},
          sort: 'id DESC',
          limit: 1
      };
      this.labeledProductService.query(params)
          .subscribe((labeledProducts) => {
            if (labeledProducts.length > 0 && barcode != "" && barcode.length == 13){
              this.barcode = null
              this.labeledProduct = labeledProducts[0];
              this.getProductPhotos(this.labeledProduct);
              this.getStockByShop(this.labeledProduct.id, this.shop_id_origin);
            }else{
              this.labeledProduct = {
                barcode:barcode
              };
              this.labeledProductShopsStock = []
            }
      });
    } 
  }

  getProductPhotos(labeledProduct){
    this.labeledProductService.getProductPhotos(labeledProduct.id)
    .subscribe((result) => {
        this.photos = result;
    })
  }

  getStockByShop(id, shop_id){
    let params = {
        where:{labeledproduct: id}
    }
    this.labeledProductShopStockService.query(params).subscribe((labeledProductShopStock) => {
        this.labeledProductShopsStock = labeledProductShopStock.filter((l)=>{
          return l.shop.id == shop_id;
        });
    });
  } 

  addProduct(){
    let productIdToBeAdded = this.labeledProduct.id;
    let product = this.transferLabeledProducts.filter((t)=>{
      return t.labeledproduct.id === productIdToBeAdded
    })
    let alreadyAdded = product && product.length > 0? true:false;
    if (!alreadyAdded && this.labeledProductShopsStock && this.labeledProductShopsStock[0] && this.labeledProductShopsStock[0].stock >= parseInt(this.stock_to_move) && parseInt(this.stock_to_move) > 0){
      let body = {
        labeledproduct_id: productIdToBeAdded,
        transfer_id: this.transfer.id,
        stock_to_move: parseInt(this.stock_to_move)
      }
      if (body.labeledproduct_id && body.labeledproduct_id > 0){
        this.transferLabeledProductService.create(body)
        .subscribe((transfer) => {
          this.getTransferLabeledProducts();
          this.labeledProduct = {};
        });
      }else{
        this.toastr.error('', 'Se ha producido un error, por favor intentelo de nuevo', {dismiss: "controlled",showCloseButton:true});
      }
    }else{
      if (alreadyAdded && product[0] && parseInt(product[0].stock_to_move) > 0){
        var r = confirm("Ya has añadido este producto al listado, ¿Esta seguro de que añadir ese stock extra al producto?");
          if (r == true) {
            let body = {
              id: product[0].id,
              stock_to_move: parseInt(this.stock_to_move) + parseInt(product[0].stock_to_move)
            }
            if (this.labeledProductShopsStock[0].stock >= body.stock_to_move){
              this.transferLabeledProductService.update(body)
              .subscribe((transfer) => {
                this.toastr.success('', 'Stock actualizado', {dismiss: "controlled",showCloseButton:true,toastLife: 2000});
                this.getTransferLabeledProducts();
                this.labeledProduct = {};
              });
            }else{
              this.toastr.error('', 'No hay stock suficiente para añadir este producto', {dismiss: "controlled",showCloseButton:true});
            }
        }
      }else{
        this.toastr.error('', 'No hay stock suficiente para añadir este producto, o no has añadido stock', {dismiss: "controlled",showCloseButton:true});
      }
    }
  }

  delete(transferLabeledProduct){
    this.transferLabeledProductService.delete(transferLabeledProduct.id)
    .subscribe((transfer) => {
      this.getTransferLabeledProducts();
    });
  }

  validate(transferLabeledProduct){
    this.transferLabeledProductService.validate(transferLabeledProduct)
    .subscribe((transfer) => {
      this.getTransferLabeledProducts();
    });
  }

  checkIfAllValidated(){
    let allValidated = true
    this.transferLabeledProducts.forEach((e)=>{
      if (e.validated === 0){
        allValidated = false;
      }
    });
    if (allValidated && this.transferLabeledProducts && this.transferLabeledProducts.length > 0){
      this.transferService.update({id:this.transfer.id, all_validated: 1}).subscribe(()=>{
      });
    }
  }

  validateAll(){
    this.transferLabeledProducts.forEach((transferLabeledProduct)=>{
      this.validate(transferLabeledProduct);
    })
  }

  loadFile(url,callback){
    JSZipUtils.getBinaryContent(url,callback);
  }

  downloadAndCloseTransfer(){
    if (this.transfer.finished){
      this.download();
    }else{
      this.transferService.update({id:this.transfer.id, finished: new Date()}).subscribe(()=>{
        this.transfer.finished = new Date();
        this.download();
      })
    }
  }

  download(){
    var opts = {
      centered : false,
      getImage: function(image){
        return image;
      },
    
      getSize: function(img,tagValue, tagName) {
        if (tagName == 'imageCB'){
          return [100,33];}
           if (tagName == 'barcode'){
          return [100,33]
        }else{
          return [300,204];
        }
      }
    }

    var imageModule=new ImageModule(opts);
    var _this = this;
   
    this.loadFile("assets/transfer_template.docx",function(error,content){
      if (error) { throw error };
      var zip = new JSZip(content);
      var doc=new Docxtemplater()
              .attachModule(imageModule)
              .loadZip(zip)
    
      var products = [];
      _this.transferLabeledProducts.forEach(function (transferLabeledProduct){
        products.push(transferLabeledProduct)
      })
      doc.setData({
        products: products,
        number:_this.transfer.id != undefined? _this.transfer.id: '',
        date:_this.transfer.createdAt != undefined?moment(_this.transfer.createdAt).format("DD-MM-YYYY"): '',
        createdby: _this.transfer.createdBy? _this.transfer.createdBy.username:"",
        shop_origin:_this.transfer.shop_id_origin.name,
        shop_destination:_this.transfer.shop_id_destination.name
      });
      try {
          // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
          doc.render()
      }
      catch (error) {
          var e = {
              message: error.message,
              name: error.name,
              stack: error.stack,
              properties: error.properties,
          }
          console.log(JSON.stringify({error: e}));
          // The error thrown here contains additional information when logged with JSON.stringify (it contains a property object).
          throw error;
      }

      var out=doc.getZip().generate({
          type:"blob",
          mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      }) //Output the document using Data-URI
      //saveAs(out,"output.docx")
      FileSaver.saveAs(out, 'trasvase_'+_this.transfer.id+'.docx');  
    })


  }



}


// WEBPACK FOOTER //
// ./src/app/transfer/components/view-transfer/view-transfer.component.ts